module.exports = __webpack_public_path__ + "img/scene1.9b901a4a.png";